export default __webpack_public_path__ + "static/placeholder-1adeac050a6ac112f5ce5b03c149286a.jpg";